// extracted by mini-css-extract-plugin
export default {"container":"LLocY","scrollable":"Q7aOG","content":"asoDP"};